import { render, staticRenderFns } from "./FieldsetProductGeneral.yaml?vue&type=template&id=83adaa0c&component"
import script from "./FieldsetProductGeneral.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetProductGeneral.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports